module.exports = __webpack_public_path__ + "static/media/EmployeeSelectionGrey.cf4f39ab.svg";